import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { EmpresaModel } from '../models/empresa-model';
import { SetorModel } from '../models/setor-model';
import { GrupoModel } from '../models/grupo-model';
import { Funcoes, Periodos } from '../services/funcoes';
import { Services } from '../services/servicos';
import { TecnicaModel } from './tecnica-model';
import { FuncionarioModel } from '../helpers/funcionario-model';

@Component({
  selector: 'app-tecnica',
  templateUrl: './tecnica.component.html',
  styleUrls: ['./tecnica.component.css']
})
export class TecnicaComponent implements OnInit {
  //DECLARAÇÕES
  funcoes: Funcoes = new Funcoes();
  //
  //INI VARIÁVES
  empresas: EmpresaModel[];
  selecionarEmpresa: EmpresaModel;

  tecnico: FuncionarioModel[];
  selecionarFuncionario: FuncionarioModel;

  grupo: GrupoModel[];
  selecionarGrupo: GrupoModel;

  setor: SetorModel[];
  selecionarSetor: SetorModel;

  periodos: Periodos[];
  selecionarPeriodo: string;

  data_inicial: Date = new Date();
  data_final: Date = new Date();
  grafico: any;
  grafico_bar: any;

  lista: TecnicaModel[];
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total: number
  loading: boolean = true;
  filtros: TecnicaModel = new TecnicaModel();

  //A - Total Equipamentos
  listaGeral: TecnicaModel[];
  listaTotalEquipamentos: TecnicaModel[];
  totalTotalEquipamentos: number
  displayTotalEquipamentos: boolean;
  //B - Manutenção Corretiva
  listaManutencaoCorretiva: TecnicaModel[];
  totalManutencaoCorretiva: number
  displayManutencaoCorretiva: boolean;
  //C - Manutenção Preventiva	
  listaTecnica: TecnicaModel[];
  totalTecnica: number
  displayTecnica: boolean;
  //D - Outros	
  listaOutros: TecnicaModel[];
  totalOutros: number
  displayOutros: boolean;
  //FIM VARIÁVEIS

  constructor(private service: Services,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private config: PrimeNGConfig) {

    this.periodos = this.funcoes.Periodos;
    if (this.periodos.length > 0) {
      this.selecionaMesAtual();
    }
    
    //this.origens = this.funcoes.Origens;
  }

  selecionaMesAtual() {
    var today = new Date();
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    this.selecionarPeriodo = this.periodos.find(c => c.cod == mm).nome;
    console.log(this.selecionarPeriodo);
    this.selecionaPeriodo(this.selecionarPeriodo);
  }

  ngOnInit(): void {

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    });

    //BUSCANDO EMPRESAS
    try {
      this.service.listarEmpresas()
        .subscribe(data => {
          if (data.Success) {
            this.empresas = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO EMPRESAS     

    //BUSCANDO FUNCIONARIO
    try {
      this.service.listarFuncionario()
        .subscribe(data => {
          if (data.Success) {
            this.tecnico = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO EMPRESAS   

    //BUSCANDO GRUPO
    try {
      this.service.listarGrupo()
        .subscribe(data => {
          if (data.Success) {
            this.grupo = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }

    //BUSCANDO SETOR
    try {
      this.service.listarSetor()
        .subscribe(data => {
          if (data.Success) {
            this.setor = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO EMPRESAS 

    this.selecionaMesAtual();
    //PESQUISANDO AO ABRIR
    this.pesquisar();
  }

  pesquisar() {
    this.loading = true;

    this.filtros.filtro_data_inicial = this.data_inicial;
    this.filtros.filtro_data_final = this.data_final;
    this.filtros.coligada = this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia;
    this.filtros.setor = this.selecionarSetor == null ? "" : this.selecionarSetor.nome;
    this.filtros.mec = this.selecionarFuncionario == null ? "" : this.selecionarFuncionario.apelido;
    this.filtros.grupo = this.selecionarGrupo == null ? "" : this.selecionarGrupo.nome;

    try {
      this.service.listarTecnica(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.lista = data.Response;
            this.total = this.lista.length;
            this.loading = false;
            this.updateChart(data.Response);

          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  onRowSelect(event) {

    try {
      this.service.listarTecnicaOrigem(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.listaGeral = data.Response;

            if (event.data.descricaoTitulo == "E - Chamado repetitivo (3 ou + chamados)") {
              this.displayTecnica = true;
              this.listaTecnica = this.listaGeral;
              this.totalTecnica = this.listaTecnica.length;
            }
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  comparandoDatasTitulosVencer(vencimento: Date) {
    var today = new Date();
    var DataVencimento = new Date(vencimento);
    console.log(DataVencimento);
    console.log(today);

    return (DataVencimento > today);
  }

  updateChart(chart: TecnicaModel[]) {

    this.grafico = {
      labels: [
        'B - Manutenção Corretiva',
        'C - Chamados',
        'D - Taxa de Chamados (Qtd Chamados/Qts equipamentos)',
        'E - Chamado repetitivo (3 ou + chamados)'],
      datasets: [
        {
          data: [chart[1].total_atendimento, chart[2].total_atendimento, chart[3].total_atendimento, chart[4].total_atendimento],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#b01ea9",
            "#0b7324",
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#b01ea9",
            "#0b7324",
          ]
        }]
    };
  }

  onChangePeriodo(event) {
    if (event.value != null) {
      this.selecionaPeriodo(event.value);
      console.log(event);
    }
  }

  selecionaPeriodo(mes: string) {
    console.log('LOKOOOOO' + mes);
    if (mes == "Todos") {
      this.data_inicial = new Date(1950, 1, 1);
      this.data_final = new Date();
    }
    else if (mes == "3 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 111));
      this.data_final = new Date();
      console.log((today.getDay() - 90));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "6 Meses") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 201));
      this.data_final = new Date();
      console.log((today.getDay() - 180));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "9 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 291));
      this.data_final = new Date();
      console.log((today.getDay() - 270));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "1 Ano") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 386));
      this.data_final = new Date();
      console.log((today.getDay() - 365));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "Janeiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 0, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Fevereiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 1, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Março") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 2, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Abril") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 3, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Maio") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 4, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Junho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 5, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Julho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 6, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Agosto") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 7, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Setembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 8, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Outubro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 9, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Novembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 10, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Dezembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 11, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
  }

}
